// source: icws_proto/icws_api_gateway/storage/get_document.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var icws_proto_icws_api_gateway_storage_storage_types_pb = require('../../../icws_proto/icws_api_gateway/storage/storage_types_pb.js');
goog.object.extend(proto, icws_proto_icws_api_gateway_storage_storage_types_pb);
var icws_proto_icws_api_gateway_storage_base_pb = require('../../../icws_proto/icws_api_gateway/storage/base_pb.js');
goog.object.extend(proto, icws_proto_icws_api_gateway_storage_base_pb);
var icws_proto_icws_api_gateway_processing_base_pb = require('../../../icws_proto/icws_api_gateway/processing/base_pb.js');
goog.object.extend(proto, icws_proto_icws_api_gateway_processing_base_pb);
goog.exportSymbol('proto.InkCapture.GetDocumentRequest', null, global);
goog.exportSymbol('proto.InkCapture.GetDocumentResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InkCapture.GetDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.InkCapture.GetDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InkCapture.GetDocumentRequest.displayName = 'proto.InkCapture.GetDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InkCapture.GetDocumentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.InkCapture.GetDocumentResponse.repeatedFields_, null);
};
goog.inherits(proto.InkCapture.GetDocumentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InkCapture.GetDocumentResponse.displayName = 'proto.InkCapture.GetDocumentResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InkCapture.GetDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.InkCapture.GetDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InkCapture.GetDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.GetDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    variant: jspb.Message.getFieldWithDefault(msg, 3, 0),
    includeScans: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    allowDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InkCapture.GetDocumentRequest}
 */
proto.InkCapture.GetDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InkCapture.GetDocumentRequest;
  return proto.InkCapture.GetDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InkCapture.GetDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InkCapture.GetDocumentRequest}
 */
proto.InkCapture.GetDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.InkCapture.ImageVariantType} */ (reader.readEnum());
      msg.setVariant(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeScans(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InkCapture.GetDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InkCapture.GetDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InkCapture.GetDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.GetDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {!proto.InkCapture.ImageVariantType} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.InkCapture.GetDocumentRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.GetDocumentRequest} returns this
 */
proto.InkCapture.GetDocumentRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.InkCapture.GetDocumentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.GetDocumentRequest} returns this
 */
proto.InkCapture.GetDocumentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ImageVariantType variant = 3;
 * @return {!proto.InkCapture.ImageVariantType}
 */
proto.InkCapture.GetDocumentRequest.prototype.getVariant = function() {
  return /** @type {!proto.InkCapture.ImageVariantType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.InkCapture.ImageVariantType} value
 * @return {!proto.InkCapture.GetDocumentRequest} returns this
 */
proto.InkCapture.GetDocumentRequest.prototype.setVariant = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.GetDocumentRequest} returns this
 */
proto.InkCapture.GetDocumentRequest.prototype.clearVariant = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.GetDocumentRequest.prototype.hasVariant = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool include_scans = 4;
 * @return {boolean}
 */
proto.InkCapture.GetDocumentRequest.prototype.getIncludeScans = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.InkCapture.GetDocumentRequest} returns this
 */
proto.InkCapture.GetDocumentRequest.prototype.setIncludeScans = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.GetDocumentRequest} returns this
 */
proto.InkCapture.GetDocumentRequest.prototype.clearIncludeScans = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.GetDocumentRequest.prototype.hasIncludeScans = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool allow_deleted = 5;
 * @return {boolean}
 */
proto.InkCapture.GetDocumentRequest.prototype.getAllowDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.InkCapture.GetDocumentRequest} returns this
 */
proto.InkCapture.GetDocumentRequest.prototype.setAllowDeleted = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.GetDocumentRequest} returns this
 */
proto.InkCapture.GetDocumentRequest.prototype.clearAllowDeleted = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.GetDocumentRequest.prototype.hasAllowDeleted = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.InkCapture.GetDocumentResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InkCapture.GetDocumentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.InkCapture.GetDocumentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InkCapture.GetDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.GetDocumentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    document: (f = msg.getDocument()) && icws_proto_icws_api_gateway_storage_base_pb.Document.toObject(includeInstance, f),
    tasksList: jspb.Message.toObjectList(msg.getTasksList(),
    icws_proto_icws_api_gateway_processing_base_pb.Task.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InkCapture.GetDocumentResponse}
 */
proto.InkCapture.GetDocumentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InkCapture.GetDocumentResponse;
  return proto.InkCapture.GetDocumentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InkCapture.GetDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InkCapture.GetDocumentResponse}
 */
proto.InkCapture.GetDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = new icws_proto_icws_api_gateway_storage_base_pb.Document;
      reader.readMessage(value,icws_proto_icws_api_gateway_storage_base_pb.Document.deserializeBinaryFromReader);
      msg.setDocument(value);
      break;
    case 3:
      var value = new icws_proto_icws_api_gateway_processing_base_pb.Task;
      reader.readMessage(value,icws_proto_icws_api_gateway_processing_base_pb.Task.deserializeBinaryFromReader);
      msg.addTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InkCapture.GetDocumentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InkCapture.GetDocumentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InkCapture.GetDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.GetDocumentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocument();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      icws_proto_icws_api_gateway_storage_base_pb.Document.serializeBinaryToWriter
    );
  }
  f = message.getTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      icws_proto_icws_api_gateway_processing_base_pb.Task.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.InkCapture.GetDocumentResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.GetDocumentResponse} returns this
 */
proto.InkCapture.GetDocumentResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Document document = 2;
 * @return {?proto.InkCapture.Document}
 */
proto.InkCapture.GetDocumentResponse.prototype.getDocument = function() {
  return /** @type{?proto.InkCapture.Document} */ (
    jspb.Message.getWrapperField(this, icws_proto_icws_api_gateway_storage_base_pb.Document, 2));
};


/**
 * @param {?proto.InkCapture.Document|undefined} value
 * @return {!proto.InkCapture.GetDocumentResponse} returns this
*/
proto.InkCapture.GetDocumentResponse.prototype.setDocument = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.InkCapture.GetDocumentResponse} returns this
 */
proto.InkCapture.GetDocumentResponse.prototype.clearDocument = function() {
  return this.setDocument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.GetDocumentResponse.prototype.hasDocument = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Task tasks = 3;
 * @return {!Array<!proto.InkCapture.Task>}
 */
proto.InkCapture.GetDocumentResponse.prototype.getTasksList = function() {
  return /** @type{!Array<!proto.InkCapture.Task>} */ (
    jspb.Message.getRepeatedWrapperField(this, icws_proto_icws_api_gateway_processing_base_pb.Task, 3));
};


/**
 * @param {!Array<!proto.InkCapture.Task>} value
 * @return {!proto.InkCapture.GetDocumentResponse} returns this
*/
proto.InkCapture.GetDocumentResponse.prototype.setTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.InkCapture.Task=} opt_value
 * @param {number=} opt_index
 * @return {!proto.InkCapture.Task}
 */
proto.InkCapture.GetDocumentResponse.prototype.addTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.InkCapture.Task, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.InkCapture.GetDocumentResponse} returns this
 */
proto.InkCapture.GetDocumentResponse.prototype.clearTasksList = function() {
  return this.setTasksList([]);
};


goog.object.extend(exports, proto.InkCapture);
